import KrisePanel from './KrisePanel';

globalThis.KrisePanelComponents = {
  KrisePanel,
};
